import { useEffect, useState } from "react";

import axios from "axios";
import { ChevronDownIcon, Search } from "lucide-react";
import { parsePhoneNumber } from "react-phone-number-input";

import CampaignService from "../../services/campaign.service";

import "./countryselect.css";

const APP_URL = process.env.APP_URL;

export const CountrySelect = ({ country, setCountry, mobile }) => {
  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    const parsedNumber = parsePhoneNumber(mobile);
    const campaignParameters = CampaignService.get();

    axios
      .get(`${APP_URL}/api/v6/authentication`, {
        params: { ...campaignParameters },
      })
      .then((res) => {
        const countries = res?.data?.result?.countries;
        const selected = res?.data?.result?.selected;
        setCountries(countries);

        setCountry((prev) => {
          if (!prev) {
            if (parsedNumber && parsedNumber.country) {
              return parsedNumber.country; // Returns the ISO country code, e.g., "DE" for Germany
            } else {
              return countries?.find((item) => item.id === +selected)
                ?.country_code;
            }
          } else {
            return prev;
          }
        });
        setIsLoading(false);
      });
  }, []);

  const selectedCountry = countries.find(
    (item) => item.country_code === country
  );

  return (
    <div>
      {open && (
        <div
          className="fixed w-full h-screen top-0 right-0"
          onClick={() => setOpen(false)}
        />
      )}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className={`!w-[120px] z-20 !border-solid bg-white relative flex justify-between items-center h-12 p-3 rounded !border  ${
          open ? "!border-[#363636]" : "!border-[#BFC0C3]"
        }`}
      >
        {isLoading || !selectedCountry ? (
          <span className="flex-1 mr-2 rounded h-full bg-gray-200 animate-pulse" />
        ) : (
          <div className="flex gap-2 items-center">
            <img
              src={selectedCountry?.flag}
              alt={selectedCountry?.title}
              className="h-5 w-[29px] object-cover rounded-sm my-0.5"
            />
            <span className="text-sm text-[#202020]">
              (+
              {selectedCountry?.dialing_code})
            </span>
          </div>
        )}
        <ChevronDownIcon
          className={`h-4 w-4 transition opacity-50 ${open && "rotate-180 "}`}
        />
      </button>
      {!isLoading && (
        <div
          className={`${
            open ? "block" : "hidden"
          } max-h-[448px] p-1 overflow-y-hidden rounded top-[50px] border-solid border-[0.3px] border-[#BFC0C3] absolute w-full bg-white md:max-w-[328px] z-50 `}
        >
          <div className="h-full overflow-x-hidden overflow-y-hidden">
            <div className="px-2 pt-2 ">
              <div className="group relative">
                <label
                  htmlFor={"search"}
                  className={"absolute z-10 top-2.5 left-2"}
                >
                  <Search
                    className={`!w-5 !h-5 group-focus-within:[&_path]:!text-[#0EAD98] [&_circle]:!text-[#BFC0C3] group-focus-within:[&_circle]:!text-[#0EAD98] [&_path]:!text-[#BFC0C3] `}
                  />
                </label>
                <input
                  autoFocus
                  id="search"
                  className="flex h-10 w-full group rounded !border !border-solid !border-[#CECCCC] group-focus-within:!border-[#0EAD98] bg-background p-2 pl-9 text-sm ring-offset-0 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 "
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="customScrollbar pb-2 max-h-[384px] overflow-y-scroll">
              {countries
                .filter(
                  (country) =>
                    country.title
                      .toLowerCase()
                      .includes(searchInput.toLowerCase()) ||
                    country.dialing_code.includes(searchInput)
                )
                .map((countryItem, index) => {
                  return (
                    <div
                      key={index}
                      className={`px-2 w-full ${
                        countryItem?.country_code === country
                          ? "bg-[#F3FBFA]"
                          : ""
                      } hover:bg-[#F3FBFA]`}
                    >
                      <div
                        onClick={() => {
                          setCountry(countryItem?.country_code);
                          setOpen(false);
                        }}
                        key={countryItem?.country_code}
                        id={countryItem?.country_code}
                        className={`flex cursor-pointer h-12 py-3 items-center justify-between  ${
                          index > 0 &&
                          "border-t-[0.2px] border-solid border-b-0 border-x-0 border-[#bfc0c380] "
                        } `}
                      >
                        <div className="flex gap-2 items-center ">
                          <img
                            src={countryItem.flag}
                            alt={countryItem.title}
                            className="h-5 w-[29px] object-cover rounded-sm my-0.5"
                          />
                          <p className="text-base text-[#202020] truncate">
                            {countryItem.title}
                          </p>
                        </div>
                        <span className="text-sm text-[#202020]">
                          (+{countryItem.dialing_code})
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
